import FotosClass from "src/app/model/api/datos/fotosClass";
import Paging from "src/app/model/api/generic/paging";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class FotosTable extends DatabaseTable<FotosClass> {

    public async getAll(): Promise<FotosClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<FotosClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'Id', Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByLocalId(Id: number): Promise<FotosClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByOrdenLocalId(OrdenLocalId: number): Promise<FotosClass[]> {
        let records = await this.GetRecordsByIndex(0, Number.MAX_VALUE, 'OrdenLocalId', OrdenLocalId, OrdenLocalId)
        return records
    }

    public async getPaged(start: number, limit: number): Promise<Paging<FotosClass>> {
        let count = await this.GetRecordsCount()
        let data = await this.GetRecordsPage(start, limit)

        let result = new Paging<FotosClass>()
        result.page = Math.floor(start / limit) + 1
        result.total = count
        result.totalPages = Math.ceil(result.total / limit)
        result.collection = data
        result.count = data.length
        return result
    }

    public async update(record: FotosClass): Promise<number> {
        // HasGPSMetadataObservable es un BehaviorSubject de uso interno en memoria (icono de GPS en la UI),
        // nunca debe persistirse: IndexedDB no puede clonarlo (DataCloneError) al hacer structured clone.
        // Clonamos sin mutar "record" para no matar el observable en vivo que sigue usando la UI.
        const { HasGPSMetadataObservable, ...fotoParaGuardar } = record
        return await this.UpdateRecord(fotoParaGuardar as FotosClass)
    }

    public async delete(record: FotosClass): Promise<void> {
        if (!record?.LocalId) return
        await this.DeleteRecord(record.LocalId)
    }

}